module.exports = __webpack_public_path__ + "img/ref4.d24dae09.png";